module.exports = __webpack_public_path__ + "assets/img/baigongfen_3 (2).666243e1.jpg";